<div>
  <p-menubar [model]="menuItems">
    <ng-template pTemplate="start">
      <div class="header-left">
        <!-- LOGO -->
        <img
          src="assets/coursepilot.png"
          width="180"
          height="180"
          alt="Logo"
          title="Zurück zum Dashboard"
          (click)="navigateToDashboard()"
          class="logo"
        />
        <!-- Hamburger Menu -->
        <button
          type="button"
          class="hamburger-button mobile-only"
          pButton
          icon="pi pi-bars"
          (click)="mobileMenu.toggle($event)"
        ></button>
      </div>
    </ng-template>

    <ng-template pTemplate="end">
      <div class="menu-icons">
        @if (roleId >= 1) {
          <button
            pButton
            icon="pi pi-cog"
            class="settings-icon"
            title="Einstellungen"
            (click)="settingsMenu.toggle($event)"
          ></button>
        }
        <p-tieredMenu
          #settingsMenu
          [popup]="true"
          [model]="settingsMenuItems"
          appendTo="body"
        ></p-tieredMenu>

        <div class="user-profile">
          @if (profileImageDisplayUrl && profileImageDisplayUrl !== DEFAULT_AVATAR) {
            <img
              [src]="profileImageDisplayUrl"
              (error)="onImageError()"
              alt="Profilbild"
              class="profile-image"
              (click)="openProfileMenu($event)"
            />
          } @else if (profileImageDisplayUrl === DEFAULT_AVATAR) {
            <!-- Kein Bild oder URL abgelaufen: Initialen statt Platzhalter -->
            <div
              class="user-avatar profile-avatar-fallback"
              [ngStyle]="{ 'background-color': avatarBadge.color }"
              (click)="openProfileMenu($event)"
            >
              {{ avatarBadge.initials }}
            </div>
          } @else {
            <!-- Solange nicht aufgelöst ist, wird bewusst kein Bild gezeigt -->
            <p-skeleton shape="circle" size="50px"></p-skeleton>
          }
          <p-tieredMenu
            #profileMenu
            [model]="profileMenuItems"
            [popup]="true"
            appendTo="body"
          ></p-tieredMenu>
        </div>
      </div>
    </ng-template>
  </p-menubar>

  <p-tieredMenu #mobileMenu [model]="menuItems" [popup]="true"></p-tieredMenu>
</div>

<p-dialog
  header="Persönliche Daten"
  [(visible)]="displayRegisterDialog"
  [modal]="true"
  [closable]="true"
  [contentStyle]="{ 'background-color': '#ffffff' }"
>
  <div class="register-container">
    <app-profile-image-editor
      [imageUrl]="profileImageDisplayUrl"
      [userId]="userData.userId"
      [displayName]="userData.firstname + ' ' + userData.lastname"
      (imageChanged)="onProfileImageChanged($event)"
    ></app-profile-image-editor>

    @if (displayRegisterDialog) {
      @if (userDataLoaded) {
        <app-update-userdata-dialog
          [userData]="userData"
          [saving]="savingUserData"
          (close)="handleDialogClose($event)"
        ></app-update-userdata-dialog>
      } @else {
        <!-- Nur für den Fall, dass jemand klickt, bevor die Init-Antwort da ist. Der
             Kind-Dialog baut sein Formular in ngOnInit auf und darf deshalb nicht vor
             den Daten entstehen - sonst blieben die Felder dauerhaft leer. -->
        <div class="form-skeleton">
          @for (row of formSkeletonRows; track row) {
            <p-skeleton height="2.5rem"></p-skeleton>
          }
        </div>
      }
    }
  </div>
</p-dialog>
